import { EMPTY_PRELOADED_FORMS, type PreloadedForms } from '@wix/communities-blog-client-common';
import { fetchPreloadedFormsSuccess } from '../actions/fetch-preloaded-forms';

type Action = ReturnType<typeof fetchPreloadedFormsSuccess>;

/** Wix Forms resolved by the controller for the ricos slot integration. */
export default function preloadedFormsReducer(
  state: PreloadedForms = EMPTY_PRELOADED_FORMS,
  action: Action,
): PreloadedForms {
  switch (action.type) {
    case fetchPreloadedFormsSuccess.type: {
      const { forms, translations, localeDataset } = action.payload ?? EMPTY_PRELOADED_FORMS;
      return {
        forms: { ...state.forms, ...forms },
        translations: translations ?? state.translations,
        localeDataset: localeDataset ?? state.localeDataset,
      };
    }
    default:
      return state;
  }
}
